import { render, staticRenderFns } from "./NetaEventBasicDataComponent.vue?vue&type=template&id=21cf60e6&scoped=true&"
import script from "./NetaEventBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaEventBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventBasicDataComponent.vue?vue&type=style&index=0&id=21cf60e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf60e6",
  null
  
)

export default component.exports